type ErrorMessage = {
  message: string | undefined;
};

export const InlineErrorMessage: React.FC<ErrorMessage> = (prop) => {
  return (
    <div className="mb-2 mt-4 border-l-[3px] border-form-error pl-3 text-[17px] font-semibold text-form-error">
      {prop.message}
    </div>
  );
};
